const moment = require('moment');

const dbName = 'history';
const historyDurationInMinutes = 60;

module.exports = DBDriver;

function DBDriver () {
  Object.defineProperty(window, 'indexedDB', {
    value: window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB,
    configurable: true,
    enumerable: true,
    writable: true
  });
  Object.defineProperty(window, 'IDBTransaction', {
    value: window.IDBTransaction || window.webkitIDBTransaction || window.msIDBTransaction,
    configurable: true,
    enumerable: true,
    writable: true
  });
  Object.defineProperty(window, 'IDBKeyRange', {
    value: window.IDBKeyRange || window.webkitIDBKeyRange || window.msIDBKeyRange,
    configurable: true,
    enumerable: true,
    writable: true
  });
}

DBDriver.prototype.initialize = function () {
  _.bindAll(this,
    'openDB',
    'deleteDB',
    'getVersion',
    'storeVersion',
    'deleteVersion',
    'isLastDBVersion',
    'cleanOldVersions',
    'iterateCurrentPageVersions'
  );

  return this;
};

DBDriver.prototype.openDB = function () {
  const deferred = $.Deferred();
  const req = window.indexedDB.open('history');

  req.onsuccess = _.bind(function () {
    this.db = req.result;
    this.db.onerror = function (event) {
      console.error('Database error: ' + event.target.errorCode);
    };

    deferred.resolve();
  }, this);

  req.onupgradeneeded = _.bind(function (event) {
    const db = event.target.result;
    const objectStore = db.createObjectStore('versions', {
      keyPath: 'version',
      autoIncrement: true
    });

    objectStore.createIndex('parent', 'parent', { unique: false });
    objectStore.createIndex('project', 'project', { unique: false });
    objectStore.createIndex('page', 'page', { unique: false });
    objectStore.createIndex('timestamp', 'timestamp', { unique: false });
  }, this);

  return deferred.promise();
};

DBDriver.prototype.deleteDB = function () {
  const deferred = $.Deferred();
  const req = indexedDB.deleteDatabase(dbName);

  try { this.db.close(); } catch (e) {}
  req.onsuccess = _.bind(deferred.resolve, deferred);
  req.onerror = _.bind(deferred.reject, deferred);
  req.onblocked = _.bind(deferred.rejectWith, deferred, 'Couldn\'t delete database due to the operation being blocked');

  return deferred.promise();
};

DBDriver.prototype.cleanOldVersions = function () {
  const deferred = $.Deferred();
  const now = moment();
  const objectStore = this._getDBRecordStore();

  objectStore.openCursor().onsuccess = _.bind(function (event) {
    const cursor = event.target.result;
    const v = cursor && cursor.value;

    if (cursor) {
      if (!v.timestamp || moment(v.timestamp).add(historyDurationInMinutes, 'minutes') < now) {
        this.deleteVersion(v.version, objectStore)
          .then(_.bind(cursor.continue, cursor));
      } else {
        cursor.continue();
      }
    } else deferred.resolve();
  }, this);

  return deferred.promise();
};

DBDriver.prototype.deleteVersion = function (key, objectStore) {
  objectStore = objectStore || this._getDBRecordStore();

  const deferred = $.Deferred();
  const req = objectStore.delete(key);

  req.onsuccess = function (evt) {
    // INKIVE.C.IS_DEV && console.warn('History: old version removed ['+key+']');
    deferred.resolve();
  };

  req.onerror = function (evt) {
    INKIVE.C.IS_DEV && console.error(evt.target.errorCode);
    deferred.rejectWith(evt.target.errorCode);
  };

  return deferred.promise();
};

DBDriver.prototype.storeVersion = function (version) {
  const deferred = $.Deferred();
  const objectStore = this._getDBRecordStore();
  const req = objectStore.add(version);

  req.onsuccess = _.bind(function (event) {
    deferred.resolve(req.result);
    // INKIVE.C.IS_DEV && console.warn('History: new version added ['+req.result+']');
  }, this);

  return deferred.promise();
};

DBDriver.prototype.getVersion = function (version) {
  const deferred = $.Deferred();

  this._getDBRecordStore().get(version).onsuccess = function (event) {
    event.target.result && deferred.resolve(event.target.result);
    event.target.result || deferred.reject();
  };

  return deferred.promise();
};

DBDriver.prototype.iterateCurrentPageVersions = function (handler) {
  const objectStore = this._getDBRecordStore();
  const index = objectStore.index('project');
  const thisProject = IDBKeyRange.only(INKIVE.C.BOOK.encodedId);

  index.openCursor(thisProject).onsuccess = function (event) {
    const cursor = event.target.result;
    const version = cursor && cursor.value;
    const ignoreThisVersion = (cursor && version.page !== INKIVE.Tool._current_page_number);

    ignoreThisVersion || handler(cursor);
    ignoreThisVersion && cursor.continue();
  };
};

DBDriver.prototype.isLastDBVersion = function () {
  return true;
};

DBDriver.prototype._getDBRecordStore = function () {
  const transaction = this.db.transaction(['versions'], 'readwrite');
  transaction.onerror = function () { console.error('DB transaction error', arguments); };

  return transaction.objectStore('versions');
};
